import { systemDefaultValues } from "../constants/system.js";
import { AppConfigTypes } from "../types/appConfig.js";
export const appConfigMeta = {
    generalSettings: {
        sendBySmsEnabled: {
            value: false,
            title: "Sending by SMS",
            description: "Allows SMS's to be sent by the app.",
            type: AppConfigTypes.BOOLEAN,
        },
        supportContact: {
            value: "",
            title: "Contact Details for Support",
            description: "How users can reach you for assistance. i.e. support@email.com / 0444 444 444",
            type: AppConfigTypes.STRING,
        },
        timezone: {
            value: systemDefaultValues.timezone,
            title: "Timezone",
            description: `Select the preferred timezone for date and time conversions.`,
            type: AppConfigTypes.SELECT,
        },
    },
    entities: {
        admin: {
            value: "Admin",
            title: "Admin",
            description: `The text entity 'Admin' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        admins: {
            value: "Admins",
            title: "Admins",
            description: `The text entity 'Admins' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        booking: {
            value: "Booking",
            title: "Booking",
            description: `The text entity 'Booking' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        bookings: {
            value: "Bookings",
            title: "Bookings",
            description: `The text entity 'Bookings' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        bookingPage: {
            value: "Booking Page",
            title: "Booking Page",
            description: `The text entity 'Booking Page' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        bookingPages: {
            value: "Booking Pages",
            title: "Booking Pages",
            description: `The text entity 'Booking Pages' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        externalUser: {
            value: "External User",
            title: "External User",
            description: `The text entity 'External User' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        externalUsers: {
            value: "External Users",
            title: "External Users",
            description: `The text entity 'External Users' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        manager: {
            value: "Manager",
            title: "Manager",
            description: `The text entity 'Manager' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        managers: {
            value: "Managers",
            title: "Managers",
            description: `The text entity 'Managers' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        respondent: {
            value: "Respondent",
            title: "Respondent",
            description: `The text entity 'Respondent' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        respondents: {
            value: "Respondents",
            title: "Respondents",
            description: `The text entity 'Respondents' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        survey: {
            value: "Survey",
            title: "Survey",
            description: `The text entity 'Survey' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        surveys: {
            value: "Surveys",
            title: "Surveys",
            description: `The text entity 'Surveys' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        surveyResponse: {
            value: "Survey Response",
            title: "Survey Response",
            description: `The text entity 'Survey Response' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        surveyResponses: {
            value: "Survey Responses",
            title: "Survey Responses",
            description: `The text entity 'Survey Responses' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        surveyType: {
            value: "Survey Type",
            title: "Survey Type",
            description: `The text entity 'Survey Type' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
        surveyTypes: {
            value: "Survey Types",
            title: "Survey Types",
            description: `The text entity 'Survey Types' will be replaced throughout the app with this custom name.`,
            type: AppConfigTypes.STRING,
        },
    },
    respondents: {
        respondentStatus: {
            value: false,
            title: "Respondent Status",
            description: "Allow respondents to have status indicators.",
            type: AppConfigTypes.BOOLEAN,
        },
        requireContactMobile: {
            value: false,
            title: "Require Contact Mobile",
            description: "Make the contact mobile field of respondents mandatory.",
            type: AppConfigTypes.BOOLEAN,
        },
        custom01: {
            value: "",
            title: "Custom Field 1",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom02: {
            value: "",
            title: "Custom Field 2",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom03: {
            value: "",
            title: "Custom Field 3",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom04: {
            value: "",
            title: "Custom Field 4",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom05: {
            value: "",
            title: "Custom Field 5",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom06: {
            value: "",
            title: "Custom Field 6",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom07: {
            value: "",
            title: "Custom Field 7",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom08: {
            value: "",
            title: "Custom Field 8",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom09: {
            value: "",
            title: "Custom Field 9",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
        custom10: {
            value: "",
            title: "Custom Field 10",
            description: "Set the name for a custom field for respondents. Any fields with a name value will be in use, to disable the field, set the name to be empty. These fields can be set by an admin, or can also be set by answering a survey question with the relevant property configured.",
            type: AppConfigTypes.STRING,
        },
    },
    images: {
        favicon: {
            value: "",
            title: "Favicon",
            description: "Favicon image. This image is shown in the browser tab at the top of the browser.",
            type: AppConfigTypes.IMAGE,
        },
        sidebarLogo: {
            value: "",
            title: "Sidebar logo",
            description: "Logo for the sidebar. This image is shown above the sidebar on the left side of the website.",
            type: AppConfigTypes.IMAGE,
        },
        tenantLogo: {
            value: "",
            title: "Tenant logo",
            description: "Logo for the tenant. This image is shown on the login page, as well as redirect screens that lead to the login page.",
            type: AppConfigTypes.IMAGE,
        },
        pdfHeader: {
            value: "",
            title: "PDF header",
            description: "Header image for the PDF. This image is shown at the top of each page when a PDF is generated.",
            type: AppConfigTypes.IMAGE,
        },
        defaultSurveySplash: {
            value: "",
            title: "Default survey splash",
            description: "Default splash image for surveys. This image is automatically added to the survey editor when a new survey is created, however it may be removed via the editor also.",
            type: AppConfigTypes.IMAGE,
        },
        emailConfirmationLogo: {
            value: "",
            title: "Email confirmation logo",
            description: "Logo for email confirmation. This image will be shown in any emails sent out when an email is created, updated, or cancelled, if the {logo} replacement string is included in the Confirmation Text editor.",
            type: AppConfigTypes.IMAGE,
        },
    },
    bookings: {
        disableAnyManagerAtLocation: {
            value: false,
            title: `Disables the 'Any manager at location' option in bookings pages`,
            description: `When enabled, booking pages will not allow the person completing them to select the option 'Any manager at location', they will be required to select a specific manager`,
            type: AppConfigTypes.BOOLEAN,
        },
        allowAffiliate: {
            value: false,
            title: "Allow Affiliate Bookings",
            description: `When enabled, Booking Pages can be configured to allow selecting an affiliate location. If this option is then selected when making a booking via the booking page, the user may only select a service, date, time, and complete the booking and service survey if present. Affiliate Bookings will be displayed in a separate tab of the Bookings Table visible only to admins, and can be marked as either Unconfirmed or Confirmed.`,
            type: AppConfigTypes.BOOLEAN,
        },
        bookingConfirmationReceiver: {
            value: "",
            title: "Booking confirmation receiver",
            description: `Each time a booking is made, the email address entered in this field will receive an email with the booking's information.`,
            type: AppConfigTypes.STRING,
        },
        bookingContactNumber: {
            value: "",
            title: "Contact Number",
            description: `Shows on the public booking pages where the error message requires a contact number to be shown to the user in order to help them complete the booking.`,
            type: AppConfigTypes.STRING,
        },
        enableMobileBookingFeature: {
            value: false,
            title: "Enable Mobile Booking Feature",
            description: `When enabled, Booking Pages can be configured to facilitate mobile bookings. Mobile bookings require setting up mobile service providers (MSP), a variant of manager that can be created/ set up by an admin in the Manager profile `,
            type: AppConfigTypes.BOOLEAN,
        },
        showMSPsTravelDurationAndDistance: {
            value: false,
            title: "Show MSP Travel Duration and Distance",
            description: `When enabled, the travel duration and distance of available MSPs to a selected location are shown in mobile booking pages. Only applicable if Mobile Booking Feature is enabled. `,
            type: AppConfigTypes.BOOLEAN,
        },
        automatedBookingReminder: {
            value: false,
            title: "Automated booking reminder email",
            description: `Sends an automatic reminder email to respondents prior to their appointment.`,
            type: AppConfigTypes.BOOLEAN,
        },
        automatedBookingReminderSms: {
            value: false,
            title: "Automated booking reminder SMS",
            description: `Sends an automatic reminder SMS to respondents prior to their appointment. Requires Billing to be configured and 'Sending by SMS' to be enabled under General Settings.`,
            type: AppConfigTypes.BOOLEAN,
        },
        managerRecieveBookingConfirmationText: {
            value: false,
            title: "Manager receives a copy of respondent booking confirmation email",
            description: `When enabled, The Manager will get a copy of email that the respondent receives when the booking is placed.`,
            type: AppConfigTypes.BOOLEAN,
        },
        hoursBeforeBookingReminder: {
            value: 3,
            title: "Hours before booking to send reminder",
            description: `If automated booking reminder is enabled, sets how many hours before the appointment the reminder should be sent. Default value is 3 hours.`,
            type: AppConfigTypes.INTEGER,
            props: {
                min: 1,
                max: 72,
                allowDecimal: false,
            },
        },
        sendPostServiceSurveyHourInterval: {
            value: 1,
            title: "Hours before booking to send service surveys post-booking",
            description: `Send an email containing service surveys to the respondent after specified hours post-booking. (defaults to 1 hour)`,
            type: AppConfigTypes.INTEGER,
            props: {
                min: 1,
                max: 72,
                allowDecimal: false,
            },
        },
        postCompletionText: {
            value: "Thank you for making a booking.",
            title: "Post completion message for booking pages",
            description: `Set a message that will be displayed to users after they successfully place a booking from the booking page.`,
            type: AppConfigTypes.STRING,
            props: {
                multiline: true,
            },
        },
        enableTimeSlotInterval: {
            value: false,
            title: "Enable Time Slot Interval Feature",
            description: `By default the time slots available to select when using a booking page will be based on the service duration and will not overlap. Example: the options presented for a 1 hour service within a 3 hour work day would be: 10:00-11:00, 11:00-12:00, 12:00-13:00. With this feature enabled with an interval of 5 minutes, the options will instead be: 10:00-11:00, 10:05-11:05, 10:10-11:10, ..., 12:00-13:00.`,
            type: AppConfigTypes.BOOLEAN,
        },
        defaultTimeSlotInterval: {
            value: null,
            title: "Default Time Slot Interval",
            description: `Locations may have their time slot frequency set on a per location basis. If a location does not have a specific option selected, this default time slot interval will be used. The shortest service duration option will use the shortest service available for the currently selected location and/or booking page.`,
            type: AppConfigTypes.INTEGER_OPTIONS,
        },
        hideServiceDuration: {
            value: false,
            title: "Hide Service Duration on Booking Pages",
            description: `When enabled, the duration of services will not be displayed on booking pages.`,
            type: AppConfigTypes.BOOLEAN,
        },
    },
    payments: {
        enableOnlinePayment: {
            value: false,
            title: "Enable Online Payment",
            description: `When enabled, this allows the Booking Pages to support online payments from respondents. It also unlocks the ability to assign billing items to services and surveys. Please note that enabling this setting only makes online payment functionality available — whether a specific booking page accepts payments is determined by a separate setting within each booking page. Please note that this feature requires a Stripe account.`,
            type: AppConfigTypes.BOOLEAN,
        },
        country: {
            value: systemDefaultValues.country,
            title: "Country",
            description: "Select the country base for online payments. This will determine the available payment currencies and the available invoice timezones.",
            type: AppConfigTypes.SELECT,
        },
        currency: {
            value: systemDefaultValues.currency,
            title: "Currency",
            description: "Select the currency for online payments. This will be used for all transactions and invoices.",
            type: AppConfigTypes.SELECT,
        },
        invoiceTimezone: {
            value: "",
            title: "Invoice Timezone",
            description: `Select the timezone for invoices. This will be used to display the date and time of bookings in the invoice.`,
            type: AppConfigTypes.SELECT,
        },
        enableVariantPricing: {
            value: false,
            title: `Enable Variant Pricing`,
            description: `When enabled, locations can have variant pricing for survey billing items. During booking, if a selected location has a variant price, the survey billing items will display the variant price. If no variant price is available, the default price will be used.`,
            type: AppConfigTypes.BOOLEAN,
        },
        companyName: {
            value: "",
            title: "Invoice Company Name",
            description: `The company name that will be displayed on invoices and payment receipts.`,
            type: AppConfigTypes.STRING,
        },
        companyAddress1: {
            value: "",
            title: "Invoice Company Address Line 1",
            description: `The first line of the company address will be displayed on invoices and payment receipts. Example: 123 Main St`,
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        companyAddress2: {
            value: "",
            title: "Invoice Company Address Line 2",
            description: `The second line of the company address will be displayed on invoices and payment receipts. Example: Fitzroy, VIC 3065`,
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        bankAccountName: {
            value: "",
            title: "Bank Account Name",
            description: "The name of the bank account to be used for payments. This will be displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        bankAccountNumber: {
            value: "",
            title: "Bank Account Number",
            description: "The account number of the bank account to be used for payments. This will be displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        bankAccountBSB: {
            value: "",
            title: "Bank Account BSB",
            description: "The BSB number of the bank account to be used for payments. This will be displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        australianBusinessNumber: {
            value: "",
            title: "Australian Business Number (ABN)",
            description: `The Australian Business Number (ABN) will be displayed on invoices.`,
            type: AppConfigTypes.STRING,
        },
        referenceNumberHelpText: {
            value: "Please insert your Invoice Number as the reference number.",
            title: "Reference Number Text",
            description: "Appears on Invoice at bottom as the reference text, optionally leave blank. Displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        remittanceHelpText: {
            value: "Please send remittance advice to @email.com",
            title: "Remittance Text",
            description: "Appears on invoice at bottom as the remittance text, optionally leave blank. Displayed on Invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        queriesHelpText: {
            value: "Please send any invoice queries to @email.com",
            title: "Queries Text",
            description: "Appears on invoice at bottom as the queries text, optionally leave blank. Displayed on Invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        phone: {
            value: "",
            title: "Phone",
            description: "The phone number. This will be displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
        website: {
            value: "",
            title: "Website",
            description: "The website link. This will be displayed on invoices and payment receipts.",
            type: AppConfigTypes.STRING,
            localStorage: false,
        },
    },
    surveys: {
        sentimentAnalysis: {
            value: false,
            title: "Sentiment Analysis",
            description: "Completed surveys will be assessed by an AI to provide a brief paragraph analysing the survey response, and if the sentiment of the response is neutral, negative, or positive",
            type: AppConfigTypes.BOOLEAN,
        },
        introScreen: {
            value: false,
            title: "Intro screen",
            description: "Show intro screen before survey. The intro screen prompts managers to hand their device to a respondent to fill the survey in.",
            type: AppConfigTypes.BOOLEAN,
        },
        outroScreen: {
            value: false,
            title: "Outro screen",
            description: "Show outro screen after survey. The outro screen prompts respondents filling out a survey on a managers device to return the device once the survey is completed.",
            type: AppConfigTypes.BOOLEAN,
        },
        backgrounds: {
            value: false,
            title: "Backgrounds",
            description: "Allow survey respondents to select a survey background image.",
            type: AppConfigTypes.BOOLEAN,
        },
        themes: {
            value: false,
            title: "Themes",
            description: "Allow survey respondents to select a survey theme",
            type: AppConfigTypes.BOOLEAN,
        },
        games: {
            value: false,
            title: "Games",
            description: "Allow survey respondents to play games while answering surveys",
            type: AppConfigTypes.BOOLEAN,
        },
        textToSpeech: {
            value: true,
            title: "Text-to-speech",
            description: "Allows survey respondents to listen to survey questions via text to speech.",
            type: AppConfigTypes.BOOLEAN,
        },
        speechToText: {
            value: true,
            title: "Speech-to-text",
            description: "Allows survey respondents to answer survey questions via speech to text.",
            type: AppConfigTypes.BOOLEAN,
        },
        pdfUseLegacy: {
            value: false,
            title: "Legacy PDF generation",
            description: "Use the legacy PDF generation system for surveys. The new system has improved formatting and layout, but may have some compatibility issues with certain question types.",
            type: AppConfigTypes.BOOLEAN,
        },
        pdfCoverPage: {
            value: false,
            title: "PDF cover page",
            description: "Show cover page on Survey PDF.",
            type: AppConfigTypes.BOOLEAN,
        },
        pdfHtmlBreakNewPage: {
            value: false,
            title: "Large HTML questions start new page in PDF",
            description: "When enabled, survey questions containing large HTML content will start on a new page in the generated PDF to improve readability.",
            type: AppConfigTypes.BOOLEAN,
        },
        pdfShowPageTitles: {
            value: false,
            title: "Show page titles in PDF",
            description: "When enabled, the titles of each page in a survey will be displayed in the generated PDF.",
            type: AppConfigTypes.BOOLEAN,
        },
        pdfBasePadding: {
            value: 8,
            title: "PDF Base Padding",
            description: "Sets the base padding (in pixels) for the generated PDF documents.",
            type: AppConfigTypes.INTEGER,
            props: {
                min: 0,
                max: 50,
                allowDecimal: false,
            },
        },
    },
    helpText: {
        mobileBookingHelpDialogText: {
            value: `Please provide your personal information and preferred appointment details.`,
            title: "Mobile Booking Help Dialog",
            description: "Help text shown in the mobile booking dialog.",
            type: AppConfigTypes.STRING,
        },
        respondentFormHelpDialogText: {
            value: `If you are completing this form on behalf of another person, please enter their details, not your own.`,
            title: "Respondent Form Help Dialog",
            description: "Help text shown in the respondent form dialog.",
            type: AppConfigTypes.STRING,
        },
        availabilityKnownHelpDialogText: {
            value: "Proceed to the next step, the booking date and time will be confirmed later.",
            title: "Availability Known Help Dialog",
            description: "Help text shown when availability is known.",
            type: AppConfigTypes.STRING,
        },
        respondentDataMismatchError: {
            value: "Email is already in use but details do not match",
            title: "Respondent data mismatch error message on booking",
            description: `Set an error message that will be displayed on the booking form when submitted respondent details do not match an existing record.`,
            type: AppConfigTypes.STRING,
        },
    },
    others: {
        respondentDevelopmentalAge: {
            value: false,
            title: "Respondent developmental age",
            description: "Adds the developmental age field to respondents.",
            type: AppConfigTypes.BOOLEAN,
        },
        anonymousSurveys: {
            value: true,
            title: "Anonymous surveys",
            description: "Allows answering public surveys anonymously.",
            type: AppConfigTypes.BOOLEAN,
        },
        companies: {
            value: false,
            title: "Companies",
            description: "Enables access, as well as the creation and maintenance of company records. Companies can be assigned to booking pages, respondents, and managers. This assignment allows managers to access respondents if the respondent's current company is the same as the company assigned to the manager. Also, booking pages assigned to a company will automatically associate the bookings to the same company.",
            type: AppConfigTypes.BOOLEAN,
        },
    },
    premium: {
        nextAvailableBookings: {
            value: false,
            title: "Show next availability",
            description: "Display the next three earliest available slots on Booking Form, Step 01",
            type: AppConfigTypes.BOOLEAN,
        },
        respondentConfirmationNotifications: {
            value: false,
            title: "Book Now, Confirm Later",
            description: "Allows users to set a booking page to enable a two-step booking process where the client receives a confirmation link to confirm the booking.",
            type: AppConfigTypes.BOOLEAN,
        },
    },
    integrations: {
        iinsight: {
            enableIinsightCaseNumQuery: {
                value: false,
                title: "Enable iinsight integration",
                description: `This allows associating a booking with an iinsight case id's when creating a booking, and retrieving information from the iinsight case.`,
                type: AppConfigTypes.BOOLEAN,
            },
            caseCreationConfig: {
                enabled: {
                    value: false,
                    title: "Enable iinsight case creation",
                    description: `This allows creating a new iinsight case when creating a booking. If enabled, the user will be able to select an existing case or create a new one.`,
                    type: AppConfigTypes.BOOLEAN,
                },
                businessDivision: {
                    id: {
                        value: "",
                        title: "Business Division ID",
                        description: "ID of the business division to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Business Division Name",
                        description: "Name of the business division to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                serviceContract: {
                    id: {
                        value: "",
                        title: "Service Contract ID",
                        description: "ID of the service contract to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Service Contract Name",
                        description: "Name of the service contract to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                financeTemplate: {
                    id: {
                        value: "",
                        title: "Finance Template ID",
                        description: "ID of the finance template to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Finance Template Name",
                        description: "Name of the finance template to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                assignedTo: {
                    user_id: {
                        value: "",
                        title: "Default Assigned User ID",
                        description: "ID of the user to assign new iinsight cases to",
                        type: AppConfigTypes.STRING,
                    },
                    first_name: {
                        value: "",
                        title: "Assigned User First Name",
                        description: "First name of the user to assign new iinsight cases to",
                        type: AppConfigTypes.STRING,
                    },
                    last_name: {
                        value: "",
                        title: "Assigned User Last Name",
                        description: "Last name of the user to assign new iinsight cases to",
                        type: AppConfigTypes.STRING,
                    },
                },
                team: {
                    id: {
                        value: "",
                        title: "Team ID",
                        description: "ID of the team to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Team Name",
                        description: "Name of the team to use for new iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                confirmedStatus: {
                    id: {
                        value: "",
                        title: "Confirmed Status ID",
                        description: "ID of the status to use for confirmed iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Confirmed Status Name",
                        description: "Name of the status to use for confirmed iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                unconfirmedStatus: {
                    id: {
                        value: "",
                        title: "Unconfirmed Status ID",
                        description: "ID of the status to use for unconfirmed iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Unconfirmed Status Name",
                        description: "Name of the status to use for unconfirmed iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
                affiliateStatus: {
                    id: {
                        value: "",
                        title: "Affiliate Status ID",
                        description: "ID of the status to use for affiliate iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                    name: {
                        value: "",
                        title: "Affiliate Status Name",
                        description: "Name of the status to use for affiliate iinsight cases",
                        type: AppConfigTypes.STRING,
                    },
                },
            },
        },
        splose: {
            enabled: {
                value: false,
                title: "Enable splose integration",
                description: `This enables integration with Splose practice management system.`,
                type: AppConfigTypes.BOOLEAN,
            },
            creationEnabled: {
                value: false,
                title: "Create appointments and patients in splose",
                description: `When enabled, new appointments and patients will be created in Splose when bookings are created.`,
                type: AppConfigTypes.BOOLEAN,
            },
            location: {
                id: {
                    value: "",
                    title: "Default Splose Location ID",
                    description: "ID of the default location to use for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
                title: {
                    value: "",
                    title: "Default Splose Location Title",
                    description: "Title of the default location to use for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
            },
            practitioner: {
                id: {
                    value: "",
                    title: "Default Splose Practitioner ID",
                    description: "ID of the default practitioner to use for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
                firstname: {
                    value: "",
                    title: "Default Splose Practitioner First Name",
                    description: "First name of the default practitioner for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
                lastname: {
                    value: "",
                    title: "Default Splose Practitioner Last Name",
                    description: "Last name of the default practitioner for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
            },
            service: {
                id: {
                    value: "",
                    title: "Default Splose Service ID",
                    description: "ID of the default service to use for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
                name: {
                    value: "",
                    title: "Default Splose Service Name",
                    description: "Name of the default service to use for Splose appointments",
                    type: AppConfigTypes.STRING,
                },
            },
            testEmail: {
                value: "",
                title: "Test Email Address",
                description: "Email address used for testing the Splose integration",
                type: AppConfigTypes.STRING,
            },
            write: {
                value: "",
                title: "Enable Write Access",
                description: "When enabled, appointments can be modified in Splose",
                type: AppConfigTypes.BOOLEAN,
            },
        },
        googleCalendar: {
            calendarApiRead: {
                value: false,
                title: "Enable read access to Calendar API",
                description: `This enables read access to calendars of users belonging to your Google organization or workspace.`,
                type: AppConfigTypes.BOOLEAN,
            },
            calendarApiWrite: {
                value: false,
                title: "Enable read and write access to Calendar API",
                description: `This enables read and write access to calendars of users belonging to your Google organization or workspace.`,
                type: AppConfigTypes.BOOLEAN,
            },
            calendarApiTestEmail: {
                value: "",
                title: "Calendar API test email",
                description: `An email used for testing the functionality of the Google Calendar API.`,
                type: AppConfigTypes.STRING,
            },
        },
        outlookCalendar: {
            calendarApiRead: {
                value: false,
                title: "Enable read access to Outlook Calendar API",
                description: `This enables read access to calendars of users belonging to your Microsoft organization or workspace.`,
                type: AppConfigTypes.BOOLEAN,
            },
            calendarApiWrite: {
                value: false,
                title: "Enable read and write access to Outlook Calendar API",
                description: `This enables read and write access to calendars of users belonging to your Microsoft organization or workspace.`,
                type: AppConfigTypes.BOOLEAN,
            },
            calendarApiTestEmail: {
                value: "",
                title: "Calendar API test email",
                description: `An email used for testing the functionality of the Outlook Calendar API.`,
                type: AppConfigTypes.STRING,
            },
        },
    },
};
//# sourceMappingURL=appConfig.js.map